import React, { FC, useEffect, useState } from 'react';
import styles from './PdfPreview.module.css';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Document, Page, pdfjs } from 'react-pdf';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';

pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

interface PdfPreviewProps {
    pdfUrl: string,
    open: boolean,
    setOpen: (open: boolean) => void,
    setImage: (res: { file: File, width: number, height: number }) => void
}

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    background: '#ffffff',
    boxShadow: 24,
    maxWidth: "90vw",
    maxHeight: "80vh",
    p: 4,
    overflowY: 'scroll'
};

const PdfPreview: FC<PdfPreviewProps> = ({ pdfUrl, open, setOpen, setImage }) => {
    const handleClose = () => setOpen(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const [size, setSize] = useState({ width: undefined, height: undefined });

    useEffect(() => {
        if (size.width !== undefined && size.height !== undefined) {
            const canvas = document.getElementsByClassName('react-pdf__Page__canvas')[0] as HTMLCanvasElement;
            const component = document.getElementsByClassName('MuiModal-root')[0] as HTMLElement;
            if (component) {
                component.style.opacity = '0';

                setTimeout(() => {
                    canvas.toBlob((res) => {
                        setImage({ file: res as File, width: canvas.clientWidth, height: canvas.clientHeight });
                        setOpen(false);
                        setSize({ width: undefined, height: undefined })
                    });
                }, 1000)
            }
        }
    }, [size, setImage, setOpen])

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const pickImage = () => {
        setSize({ width: 2000, height: 2000 })
    }

    return (<div className={styles.PdfPreview} data-testid="PdfPreview">
        <Modal
            disableScrollLock={true}
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div>
                    <div data-testid="PageNr" className={styles.pages}>
                        Pagina {pageNumber} van {numPages}
                    </div>
                    {pageNumber > 1 && <Button color="secondary" data-testid="PreviousButton"  variant="outlined" onClick={() => setPageNumber(pageNumber - 1)}>
                        <ArrowLeft></ArrowLeft>Vorige</Button>}
                    {numPages > pageNumber && <Button color="secondary" data-testid="NextButton" variant="outlined" onClick={() => setPageNumber(pageNumber + 1)}>Volgende<ArrowRight></ArrowRight></Button>}
                    <div className={styles.pages}>
                        <Button color="secondary" data-testid="SelectBackgroundButton" variant="outlined" onClick={() => { pickImage() }}>Gebruik Voor Achtergrond</Button>
                    </div>
                </div>
                <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page height={size.height} width={size.width} pageNumber={pageNumber} />
                </Document>
            </Box>
        </Modal>
    </div>)
};

export default PdfPreview;
